import { ConnectWalletGuide } from 'components/ConnectWalletGuide'
// import { NoData } from 'components/NoData'
import { Responsive } from 'components/Responsive'
import { memo } from 'react'
import { useLinkConnected } from 'store/link/hooks'
import { useCurrentSpotOrderTab } from 'store/spot/hooks'
import { SpotOrderTabType } from 'store/spot/types'

import { OpenOrderView } from './OpenOrder'
import { OrderHistoryView } from './OrderHistory'
import { OrdersWrap } from './styles'

import { UserOrdersTop } from './Top'
import { TradeHistoryView } from './TradeHistory'

import { UserOrderConnect } from 'components/UserOrderConnect'

export const UserOrders = memo(() => {
  const currentOrderTab = useCurrentSpotOrderTab()
  const linkConnected = useLinkConnected()

  const renderTable = () => {
    if (currentOrderTab === SpotOrderTabType.OpenOrder) {
      return <OpenOrderView />
    } else if (currentOrderTab === SpotOrderTabType.OrderHistory) {
      return <OrderHistoryView />
    } else if (currentOrderTab === SpotOrderTabType.TradeHistory) {
      return <TradeHistoryView />
    }
    return null
  }

  return (
    <OrdersWrap>
      <UserOrdersTop />
      {linkConnected ? (
        renderTable()
      ) : (
        <Responsive mobile={<ConnectWalletGuide responsive={true} />}>
          {/* <NoData /> */}
          <UserOrderConnect />
        </Responsive>
      )}
    </OrdersWrap>
  )
})
